<template>
    <div style="padding-top: 80px">
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Detalle</p>
            </v-card-title>
            <v-form >
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-col cols="12">
                                <div class="mt-2">
                                    <span>No.Queja:</span>
                                    <p class="type-text-style">{{idQueja}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Correo:</span>
                                    <p class="type-text-style">{{quecorreo}}</p>
                                </div>
                                <div class="mt-2" v-if="this.nrreporte != null">
                                    <span>Reporte:</span>
                                    <p style="font-size:15px">
                                        <button @click="BuscarReporte()" type="button" class="mr-1" aria-haspopup="true" aria-expanded="false">
                                            <span class='reporteindice'>{{nrreporte}} - {{svindice}}</span>
                                        </button>
                                    </p>
                                </div>
                                <div class="mt-2" v-if="this.nrreporte == null">
                                    <span>Reporte:</span>
                                    <p class="type-text-style"></p>

                                </div>
                                <div class="mt-2">
                                    <span>Origen:</span>
                                    <p class="type-text-style">{{ctfConcepto}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Departamento:</span>
                                    <p class="type-text-style">{{dpnombre}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Aseguradora:</span>
                                    <p class="type-text-style">{{clnombrecorto}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Descripción:</span>
                                    <p class="type-text-style">{{quedescripcion}}</p>
                                </div>
                            </v-col>
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="6" class="media-query">
                            <v-col cols="12">
                                <div class="mt-2">
                                    <span>Quejoso:</span>
                                    <p class="type-text-style">{{quenombre}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Telefono:</span>
                                    <p class="type-text-style">{{quetelefono}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Tipo:</span>
                                    <p class="type-text-style">{{quetipoqueja}}</p>
                                </div>
                                <div class="mt-2" v-if="this.quetipoqueja === 'Externa'">
                                    <span>Folio:</span>
                                    <p class="type-text-style">{{quefolioex}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Concepto:</span>
                                    <p class="type-text-style">{{qjconcepto}}</p>
                                </div>
                                <div class="mt-2">
                                    <span>Fecha de registro:</span>
                                    <p class="type-text-style">{{quefecha}}</p>
                                </div>
                                <div class="mt-2" v-if="permisoMovimiento && (esdesc == 'Sin seguimiento' || esdesc == 'Seguimiento')">
                                    <span>Agregar movimiento</span>
                                    <br />
                                    <v-btn density="compact" color="primary" class="ma-1" title="Agregar Movimiento" @click="activarMovimiento()"><v-icon>mdi-plus</v-icon></v-btn>
                                </div>
                            </v-col>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showMovimiento">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Movimiento</p>
            </v-card-title>
            <v-form ref="form">
                <v-card-text>
                    <v-col cols="12" sm="12" md="12">
                        <span style="font-weight: bold;">Observaciones</span>
                        <v-textarea @input="uppercase('observaciones')"
                                    v-on:blur="observaciones = observaciones != null ? observaciones.trim() : null"
                                    :counter="1000" :rules="rulestextarea" outlined rows="4"  v-model="observaciones"></v-textarea>
                    </v-col>
                    <v-row justify="center">
                        <v-btn class="ma-2" color="primary"
                               @click="guardarMovimiento('Seguimiento')" :disabled="disabledbutton">
                            <span style='color: white;'>SEGUIMIENTO</span>
                        </v-btn>
                        <v-btn class="ma-2" color="primary"
                               @click="guardarMovimiento('Procedente')" :disabled="disabledbutton">
                            <span style='color: white;'>PROCEDENTE</span>
                        </v-btn>
                        <v-btn class="ma-2" color="primary"
                               @click="guardarMovimiento('Improcedente')" :disabled="disabledbutton">
                            <span style='color: white;'>IMPROCEDENTE</span>
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Seguimiento</p>
            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">
                            <DataTable :url="urlBusqueda"
                                       :columns="columnsBusqueda"
                                       :params="datos"
                                       @apiDT="apiDT = $event"
                                       :order="[[ 1, 'asc' ]]"></DataTable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>

<script>
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import Quejas from "@/services/Quejas/Quejas.service.js";
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    import Menu from '@/components/pages/Quejas/Menu/Menu.vue';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                datos: {
                    idQueja: null,
                },
                showMovimiento: false,
                permisoMovimiento: false,
                disabledbutton: false,
                observaciones: null,
                aiclave: null,
                svfhconclusion: null,
                idQueja: null,
                quecorreo: null,
                nrreporte: null,
                svindice: null,
                dpnombre: null,
                clnombrecorto: null,
                quedescripcion: null,
                esdesc: null,
                quenombre: null,
                quetelefono: null,
                quetipoqueja: null,
                qjconcepto: null,
                quefecha: null,
                ctfConcepto: null,
                quefolioex: null,
                rulestextarea: [//v => !!v || 'Campo requerido',
                    v => {
                        if (v == null || v == '') {
                            return 'Campo requerido'
                        }
                        else {
                            if (v.length < 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else if (v.length > 1000) {
                                return 'Máximo 1000 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                urlBusqueda: "Quejas/obtenerSeguimiento",
                columnsBusqueda: [
                    { name: 'seqdescripcion', data: 'seqdescripcion', title: "Seguimiento" },
                    { name: 'uslogin', data: 'uslogin', title: "Usuario" },
                    { name: 'seqfecha', data: 'seqfecha', title: "Fecha" },
                ],
            }
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
        },
        watch: {
            
        },
        methods: {
            activarMovimiento() {
                this.showMovimiento = true;
            },
            async guardarMovimiento(x) {
                this.disabledbutton = true;
                this.$refs.form.validate();

                if (this.$refs.form.validate()) {
                    this.$swal({
                        position: 'center',
                        title: 'Guardando Movimiento ...',
                        html: "Espere un momento, por favor",
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    await Quejas.insertarMovimientoQueja(this, x).then(response => {
                        setTimeout(() => {
                            this.$swal.close();
                            
                            if (response) {
                                this.disabledbutton = false;
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se guardó el movimiento correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 5000,
                                }).then(async () => {
                                    this.$refs.form.reset();
                                    this.$refs.form.resetValidation();
                                    this.showMovimiento = false;
                                    await this.actualizaVista();
                                    this.apiDT.ajax.reload(null, false)
                                    //window.location.reload();
                                });



                            }
                            else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Hubo un error al guardar el movimiento, Favor de avisar a Desarrollo',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }, 2000);
                    });


                }
                else {
                    this.disabledbutton = false;
                }
                
            },
            uppercase(input) {
                if (input == "observaciones") {
                    if (this.observaciones != '' && this.observaciones != null) {
                        this.observaciones = this.observaciones.toUpperCase();
                    }
                }
            },
            async actualizaVista() {
                await Quejas.obtenerDetalleQueja(this).then(response => {
                    this.aiclave = response[0].aiclave;
                    this.svfhconclusion = response[0].svfhconclusion;

                    this.nombreTercero = response[0].nombreTercero;
                    this.quecorreo = response[0].quecorreo;
                    this.nrreporte = response[0].nrreporte;
                    this.svindice = response[0].svindice;
                    this.dpnombre = response[0].dpnombre;
                    this.clnombrecorto = response[0].clnombrecorto;
                    this.quedescripcion = response[0].quedescripcion;
                    this.esdesc = response[0].esdesc;
                    this.quenombre = response[0].quenombre;
                    this.quetelefono = response[0].quetelefono;
                    this.quetipoqueja = response[0].quetipoqueja;
                    this.qjconcepto = response[0].qjconcepto;
                    this.quefecha = response[0].quefecha;
                    this.ctfConcepto = response[0].ctfConcepto;
                    this.quefolioex = response[0].quefolioex;
                });
            },
            async BuscarReporte() {

                let reporte = {
                    nrreporte: this.nrreporte,
                    svindice: this.svindice,
                    aiclave: this.aiclave,
                    svfhconclusion: this.svfhconclusion
                };

                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", this.nrreporte);
                formData.append("svindice", this.svindice);
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });



                let routerName = MetodosGenerales.obtenerRouterName(this.aiclave.toString());


                if (ver == 0) {
                    this.$router.push({ name: `${"DatosIncompletos"}` });
                }
                else {

                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

                    let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);

                    let url = this.$router.resolve({ path: asistenciaurl + '/ReporteDetalle' });

                    window.open(url.href, '_blank');


                }
            },
            
            
        },
        async mounted() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "208"//modulo de quejas
            ).then((response) => {
                if (response.data.length == 0) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                    return
                }
            });
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "271"//modulo de quejas
            ).then((response) => {
                if (response.data.length > 0) {
                    this.permisoMovimiento = true;
                }
            });
            let quejas = await MetodosGenerales.obtenerSessionReporte('quejas');
            this.idQueja = quejas.idQueja;
            this.datos.idQueja = quejas.idQueja;

            await Quejas.obtenerDetalleQueja(this).then(response => {
                this.aiclave = response[0].aiclave;
                this.svfhconclusion = response[0].svfhconclusion;

                this.nombreTercero = response[0].nombreTercero;
                this.quecorreo = response[0].quecorreo;
                this.nrreporte = response[0].nrreporte;
                this.svindice = response[0].svindice;
                this.dpnombre = response[0].dpnombre;
                this.clnombrecorto = response[0].clnombrecorto;
                this.quedescripcion = response[0].quedescripcion;
                this.esdesc = response[0].esdesc;
                this.quenombre = response[0].quenombre;
                this.quetelefono = response[0].quetelefono;
                this.quetipoqueja = response[0].quetipoqueja;
                this.qjconcepto = response[0].qjconcepto;
                this.quefecha = response[0].quefecha;
                this.ctfConcepto = response[0].ctfConcepto;
                this.quefolioex = response[0].quefolioex;
            });

        }
    }

</script>

<style>
    @media screen and (max-width: 599px) {
        .media-query {
            margin-top: -40px;
        }
    }
</style>